import { Resource } from '../resource'


export class Country extends Resource {
    uid: string | any
    name: string | any
}